import {
  GetAllJourneysResponse,
  SetJourneyResponse,
  JourneyDetail,
} from '@fullstory/proto/fs/services/dx-objects';
import { mockJourneyDetail } from './util';

export const GET_ALL_JOURNEYS_EMPTY_RESPONSE: GetAllJourneysResponse = { journeys: [] };

export const GET_ALL_JOURNEYS_RESPONSE: GetAllJourneysResponse = {
  journeys: [mockJourneyDetail],
};

export const SET_JOURNEY_RESPONSE: SetJourneyResponse = { journey: { ...mockJourneyDetail } };

export const SET_JOURNEY_RESPONSE_WEBBER: JourneyDetail = {
  journey: {
    journeyMap: mockJourneyDetail.journey?.journeyMap || null,
    metadata: mockJourneyDetail.journey?.metadata || null,
  },
  lastViewed: null,
  starred: false,
};
